import { render, staticRenderFns } from "./BGoogleMap.vue?vue&type=template&id=ca31452c"
import script from "./BGoogleMap.vue?vue&type=script&lang=js"
export * from "./BGoogleMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports